import React, { useState, useEffect } from 'react'
import style from './header.module.scss'

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ReferenceLine,
    ResponsiveContainer,
} from 'recharts';

const GraphSales = (props) => {


    const toKilo = (decimal) => `${(decimal / 1000)}k`;
    const sumWithCommas = (payload) => {
        let sum = payload.reduce((accumulator, currentValue) => accumulator + currentValue.value, 0)
        let x = sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return x
    }


    const renderTooltipContent = (o) => {
        const { payload, label } = o;
        return (
            <div className="customized-tooltip-content">
                <p className="total">ยอดขายรวม</p>
                <h5 >฿ {`${sumWithCommas(payload)}`}</h5>
            </div>

        );
    };
    useEffect(() => {

    }, [])
    return (
        <>
            {/*<div className='selectRang'>
                <label >Date range</label>
                <select className="form-select" id="selectRange" defaultValue='0'>
                    <option value="0">This Week</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                </select>
            </div>*/}

            <section className='sec_graphSales cardStyle mb-2 w-100'>
                <a href="/" className={'btnMore'} />
                <div className='cardContent'>
                    <div className='titleCard'>
                        <h1>ยอดขาย</h1>
                        <div className='groupIcon'>
                            <div className='iconItem icon_arrow_up-2' />
                            <div className='iconItem icon_chart' />
                        </div>
                    </div>
                    <div className='detailGraph'>
                        <div className='detailCol'>
                            <div className='detailItem'>
                                <div className='iconItem icon_arrowCircle_up' />
                                <p>Savings</p>
                            </div>
                            <div className='detailItem'>
                                <div className='iconItem icon_arrow_up' />
                                <p>+6,79%</p>
                            </div>
                        </div>
                        <div className='detailCol'>
                            <div className='detailItem'>
                                <div className="circle" style={{ backgroundColor: '#FF6880' }} />
                                <p>This week</p>
                            </div>
                            <div className='detailItem'>
                                <div className="circle" style={{ backgroundColor: '#D9D9D9' }} />
                                <p>Last week</p>
                            </div>
                        </div>

                    </div>
                    <div className='graph'>
                        <ResponsiveContainer width="100%" height="100%">
                            <LineChart
                                width={500}
                                height={300}
                                data={props.sell_chart.data}
                                margin={{
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: -25,
                                }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" padding={{ left: 30, right: 30 }} />
                                <YAxis tickFormatter={toKilo} padding={{ bottom: 30, top: 30 }} />
                                <Tooltip content={renderTooltipContent} />
                                {/* <Legend /> */}
                                <Line type="monotone" dataKey="thisWeek" stroke="#FF6880" strokeWidth={3} />
                                <Line type="monotone" dataKey="lastWeek" stroke="#D9D9D9" strokeWidth={3} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>

                </div>
            </section>
        </>

    )
}
export default GraphSales